import { createSelector } from "reselect"
import { get } from "lodash"
import { computeEditingFilter, computeAddedFilters } from "helpers/filters"
import { filterSupportsContribution } from "helpers/segments"
import { computeChipSecuritiesIds } from "helpers/filters/chips"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { classificationsMap, computeClassifications } from "helpers/classification"
import { computeSecuritiesDescriptors } from "helpers/securities"
import { getTagCategories, getAttributeCategories } from "modules/portfolio-root/selectors"
import { getViewType, getCurrency } from "modules/portfolio-root/selectors/portfolios"
import { getIsActive } from "."
import { getEffectiveNormalization } from "./filter-scope"

export const getPortfolioFilters = state => get(state, "global.data.portfolioFilters.data")
const getEditing = state => state.modules.analyzeHeader.editingFilter
const getRawClassifications = (state) => get(state, "global.data.classifications.data.classifications")
export const getFilter = state => state.modules.analyzeHeader.filter
export const getFiltersVisible = state => state.modules.analyzeHeader.filtersVisible
export const getClassificationsValues = (state) => get(state, "global.data.classificationsValues.data")
const getPortfolioSecuritiesDescriptors = (state) => get(state, "global.data.portfolioSecuritiesDescriptors.data")
const getStartDate = (_, props) => get(props, "startDate")
const getAssetType = () => "PORTFOLIO"

export const getSecuritiesDescriptors = createSelector(
  [getPortfolioSecuritiesDescriptors],
  computeSecuritiesDescriptors,
)

export const getChipSecuritiesIds = createSelector(
  [getFilter],
  computeChipSecuritiesIds,
)

export const getClassifications = createSelector(
  [getRawClassifications, getStartDate],
  computeClassifications,
)

export const getFilterOns = createSelector(
  [getViewType, getPortfolioFilters, getFilter, getEditing, getTagCategories, getClassifications, getClassificationsValues, getAttributeCategories, getAssetType, getEffectiveNormalization],
  computeFilterOns,
)

export const getEditingFilter = createSelector(
  [getFilter, getEditing, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getStartDate],
  classificationsMap,
)

export const getHasUnsupportedContributionFilter = createSelector(
  [getFilter, getIsActive],
  (filter, isActive) => !filterSupportsContribution(filter, isActive),
)

export const getAddedFilters = createSelector(
  [getFilter, getFilterOns, getTagCategories, getClassifications, getSecuritiesDescriptors, getPortfolioFilters, getAttributeCategories, getClassificationsValues, getCurrency],
  (filter, filterOns, tagCategories, classificationsMetas, securitiesDescriptors, portfolioFilters, attributeCategories, classificationsValues, currency) => {
    return computeAddedFilters(filter, filterOns, {
      securitiesDescriptors,
      classificationsInfos: {
        classificationsMetas,
        classificationsValues,
      },
      tagCategories,
      portfolioFilters,
      attributeCategories,
      currency,
    })
  },
)
